import { render, staticRenderFns } from "./DashboardUserIndex.vue?vue&type=template&id=3c13126a&scoped=true&"
import script from "./DashboardUserIndex.vue?vue&type=script&lang=js&"
export * from "./DashboardUserIndex.vue?vue&type=script&lang=js&"
import style0 from "./DashboardUserIndex.vue?vue&type=style&index=0&id=3c13126a&prod&lang=css&"
import style1 from "./DashboardUserIndex.vue?vue&type=style&index=1&id=3c13126a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13126a",
  null
  
)

export default component.exports